import React, { useState, useRef, useEffect } from 'react';
import { Alert, Button, Row, Col } from 'antd';

const DescriptionAlert = ({ description }) => {
  const [expanded, setExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      const lineHeight = parseFloat(
        getComputedStyle(textRef.current).lineHeight
      );
      const maxHeight = lineHeight * 7; // 7 líneas
      setIsClamped(textRef.current.scrollHeight > maxHeight);
    }
  }, [description]);

  return (
    description && (
      <Alert
        type="info"
        style={{
          margin: '20px',
          backgroundColor: '#f1f1f1',
          borderColor: '#cccccc',
          padding: '12px',
        }}
        message={
          <div>
            <div
              ref={textRef}
              style={{
                display: '-webkit-box',
                WebkitLineClamp: expanded ? 'unset' : 7,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'pre-wrap',
              }}
            >
              {description}
            </div>
            {isClamped && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: 8,
                }}
              >
                <Button type="link" onClick={() => setExpanded(!expanded)}>
                  {expanded ? 'Ver menos' : 'Ver más'}
                </Button>
              </div>
            )}
          </div>
        }
      />
    )
  );
};

export default DescriptionAlert;
